import React, { FormEvent } from 'react';
import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useModalManager } from '@/components/common/Modal';
import showToast from '@/components/common/Toast';
import SubmitModal from '../../ui/Modal/SubmitModal';
import { plato_api_reference_material_model_reference_materials_path } from '../../../modules/routes';
import { queryClient } from '../../../utils/ReactQuery';

interface DeleteModelReferenceMaterialButtonProps {
  referenceMaterial: {
    id: number;
    title: string;
  };
  row: {
    lessonId: number;
    lessonUnitTitle: string;
    programId: number;
    programTitle: string;
    programs: { full_title_with_edition: string }[];
  };
}

const DeleteModelReferenceMaterialButton = ({ referenceMaterial, row }: DeleteModelReferenceMaterialButtonProps) => {
  const { close, isOpen, open } = useModalManager();

  const deletePath = plato_api_reference_material_model_reference_materials_path(
    referenceMaterial.id,
    { model_id: row.lessonId, model_type: 'Lesson' },
  );

  const { mutate } = useMutation({
    mutationFn: () => (
      axios
        .delete(deletePath)
        .then(async () => {
          await queryClient.invalidateQueries(['lessons', 'referenceMaterial', referenceMaterial.id]);
          showToast(
            `Successfully removed tag to ${row.lessonUnitTitle}`,
            { autoClose: 3000, position: 'bottom-right' },
          );
          close();
        })
    ),
    mutationKey: ['ModelReferenceMaterial', 'Delete', referenceMaterial.id, row.lessonId],
  });

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    mutate();
  };

  return (
    <>
      <button className="btn btn--outline-red" type="button" onClick={open}>Delete</button>
      <SubmitModal
        className="tw-text-base tw-w-[900px]"
        close={close}
        headerText="Delete Association"
        isOpen={isOpen}
        SubmitButtonProps={{
          color: 'red',
        }}
        submitText="Delete"
        onSubmit={handleSubmit}
      >
        <p className="tw-mb-4 tw-whitespace-nowrap">
          Are you sure you want to delete this association?
          This association will also be deleted from the following programs:
        </p>
        <ul className="tw-list-disc tw-ml-8 tw-flex tw-flex-col tw-gap-2">
          {row.programs.map(program => (
            <li key={program.full_title_with_edition}>
              {program.full_title_with_edition}
            </li>
          ))}
        </ul>
      </SubmitModal>
    </>
  );
};

export default DeleteModelReferenceMaterialButton;
